import { Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import { RouteGateFallback } from '@/components/routing/RouteGateFallback';
import { useJourneyAuthoringAccess } from '@/hooks/useJourneyAuthoringAccess';

/**
 * Journey authoring is held back (Oct 2026): only admins build Journeys, as
 * the server decides through get_my_journey_authoring_access. Everyone else
 * goes back to My creations. A failed check falls through to the page, which
 * shows its own retry state.
 */
function JourneyAuthoringGate({ children }: { children: React.ReactNode }) {
  const access = useJourneyAuthoringAccess();
  if (access.isLoading) return <RouteGateFallback />;
  if (access.isError) return <>{children}</>;
  if (!access.canAuthor) return <Navigate to="/my-programs" replace />;
  return <>{children}</>;
}

export function JourneyAuthoringRoute({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <JourneyAuthoringGate>{children}</JourneyAuthoringGate>
    </ProtectedRoute>
  );
}

export default JourneyAuthoringRoute;
